/**
 * Hook to extract currency and country code from booking/venue data
 * with sensible defaults (GBP / GB).
 */
export function useVenueCurrency(venue?: { currency?: string; country_code?: string | null } | null) {
  return {
    currency: venue?.currency ?? "GBP",
    countryCode: venue?.country_code ?? "GB",
  };
}
